import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import { LOCALE_ID, NgModule, Optional, SkipSelf } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { LogoComponent } from '@appShared/standalone/logo/logo.component';
import { MaterialModule } from 'app/material/material/material.module';
import { NotFoundComponent } from './components';
import { LoadingAnimationComponent } from './components/loading-animation/loading-animation.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { EnsureModuleLoadedOnceGuard } from './guards';
import { AuthInterceptorService, CacheInterceptorService, ErrorInterceptorService } from './interceptors';
import { MainLayoutComponent } from './layouts';
import { AuthService, StoreService } from './services';
import { NotServiceAvailableComponent } from './components/not-service-available/not-service-available.component';

registerLocaleData(localeEs);

// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    // components here
    declarations: [MainLayoutComponent, NotFoundComponent, NavigationComponent, LoadingAnimationComponent, NotServiceAvailableComponent],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        RouterModule,
        HttpClientModule,
        MaterialModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoader,
                deps: [HttpClient]
            },
            isolate: true
        }),
        LayoutModule,
        LogoComponent
    ],
    providers: [
        AuthService,
        StoreService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CacheInterceptorService,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptorService,
            multi: true
        },
        {
            provide: LOCALE_ID,
            useValue: 'es-ES'
        },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } }
    ],
    exports: [CommonModule, FormsModule, HttpClientModule, MainLayoutComponent]
})
export class CoreModule extends EnsureModuleLoadedOnceGuard {
    // Looks for the module in the parent injector to see if it's already been loaded (only want it loaded once)
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        super(parentModule);
    }
}
